import React from "react";
import { Grid, Skeleton } from "@mui/material";

/**
 * A loading skeleton component for location cards.
 * Displays placeholder content while booking data is being loaded.
 */

const LocationCardSkeleton = () => {
    return (
        <Grid item mb={2}>
            <Grid container justifyContent={'space-between'} alignItems={'center'} sx={{
                padding: "0.8em",
                border: "1px solid rgba(238, 238, 238, 1)",
                borderRadius: "0.5em",
                position: "relative"
            }}>
                <Grid item>
                    <Skeleton variant="text" width={200} />
                    <Skeleton variant="text" width={100} />
                </Grid>
                <Grid item>
                    <Skeleton variant="text" width={200} />
                </Grid>
            </Grid>
            <Grid spacing={2}
                container
                alignItems="center"
                sx={{ mt: '0.2em' }}>
                {[...Array(12).keys()].map((item) => (
                    <Grid item xs={12} sm={6} md={3} key={item}>
                        <Skeleton height={40} width={200} />
                        <Skeleton height={20} width={150} />
                    </Grid>
                ))}
            </Grid>
        </Grid>
    )
}

export { LocationCardSkeleton };
